import { fetcher } from "helpers/fetcher";

import {
  TUpdateCorpProfilePictureReq,
  TUpdateCorpProfilePictureRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateCorporationProfilePicture = async (
  payload: TUpdateCorpProfilePictureReq
) => {
  return await fetcher<
    TUpdateCorpProfilePictureRes,
    TUpdateCorpProfilePictureReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_PROFILE_PICTURE, {
    data: payload.data,
    fileFields: ["image"],
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.UPDATE_PROFILE_PICTURE.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateCorpProfilePicture = async (
  payload: TUpdateCorpProfilePictureReq
) => {
  return (await updateCorporationProfilePicture(payload)).data;
};

mutationUpdateCorpProfilePicture._key = (
  payload: TUpdateCorpProfilePictureReq
) => [ENDPOINT.CORPORATION.UPDATE_PROFILE_PICTURE.url, payload];
